export default __webpack_public_path__ + "static/media/Connector_TypeUnknown.240dc7f5.svg";